export const build = { date:"2026-05-21.1413", stage:"alpha" }
